import axios from 'axios';
import { getBestTier } from '@/Util/helpers.js';

export default async (commit, getters) => {
    await commit('setSoftLoaded', true);
    let data;

    let { billingPeriod, coupons, selectedAddons, selectedCharges, selectedPlanId} = getters.cartInfo;
    let includedAddons = getters.includedAddons.map(({itemId, quantity}) => {
        return {
            itemId,
            quantity
        }
    });
    let includedCharges = getters.includedCharges.map(({itemId, quantity}) => {
        return {
            itemId,
            quantity
        }
    });
    // This handles addons that are mandatory but still can be modified by the user.
    let tmpIncludedAddons = includedAddons.map(item => item.itemId);
    selectedAddons = selectedAddons.filter(item => {
        if (tmpIncludedAddons.includes(item.itemId)) {
            includedAddons.forEach(i => {
                if (i.itemId === item.itemId) {
                    i.quantity = item.quantity;
                }
            })
        }
        return !tmpIncludedAddons.includes(item.itemId);
    });

    try {
        ({data} = await axios.post('/api/v1/estimate', {
            plan: selectedPlanId,
            billingPeriod: 1,
            billingPeriodUnit: billingPeriod,
            currency: getters.userInfo.currency,
            ...(getters.featureFlags?.BN_PULL_TOTALS_FROM_CB_ESTIMATE && {includeRenewal: true}),
            addons: [
                ...includedAddons,
                ...selectedAddons
            ],
            charges: [
                ...includedCharges,
                ...selectedCharges
            ],
            couponCodes: coupons,
            billingAddress: {
                company: getters.userInfo.company,
                line1: getters.userInfo.line1,
                line2: getters.userInfo.line2,
                city: getters.userInfo.city,
                stateCode: getters.userInfo.state,
                ...(!!getters.userInfo.postalCode && {postalCode: getters.userInfo.postalCode}),
                countryCode: getters.userInfo.country,
            },
            ...(getters.isPartnerLink && {partnerAccountId: getters.purchaseInfo.partnerAccountId})
        }));
        await commit('setHasFetchedEstimate', true);
        await commit('setEstimateData', data);
    } catch (error) {
        if (window.axios.isAxiosError(error)) {
            if (!!error.response) {
                const errorObj = error.response.data;
                window.Sentry.logError(error, {server_event_id: error.response.data.eventId});
                commit('setError', {
                    active: true,
                    code: errorObj.error,
                    message: errorObj.message
                });
            } else {
                window.Sentry.logError(error);
                commit('setError', {
                    active: true,
                    code: window.constants.errorCodes.generalError,
                    message: error.message
                });
            }
        } else if (!getters.hasActiveError) {
            window.Sentry.logError(error);
            commit('setError', {
                active: true,
                code: window.constants.errorCodes.generalError
            });
        }
    } finally {
        await commit('setSoftLoaded', false);
    }
}
